module.exports = __webpack_public_path__ + "img/ic-contact-line_en.ca9b2cf0.png";